import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
    unauthorizedMessage: {
      textAlign: 'center',
      padding: '2rem',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      maxWidth: '600px',
      margin: '2rem auto',
    },
    heading: {
      color: '#dc3545',
      marginBottom: '1rem',
    },
    paragraph: {
      marginBottom: '1rem',
    },
    link: {
      backgroundColor: '#007bff',
      color: 'white',
      padding: '0.5rem 1rem',
      textDecoration: 'none',
      borderRadius: '4px',
      display: 'inline-block',
      marginTop: '1rem',
    },
  };

  const Unauthorized = () => {
    return (
      <div style={styles.appContainer}>
        <main style={styles.contentContainer}>
          <div style={styles.unauthorizedMessage}>
            <h2 style={styles.heading}>Acceso Denegado</h2>
            <p style={styles.paragraph}>No tienes los permisos necesarios para acceder a esta pagina.</p>
            <p style={styles.paragraph}>Por favor contacta a un administrador si crees que es un error.</p>
            <Link to="/" style={styles.link}>
              Regresar al inicio
            </Link>
          </div>
        </main>
      </div>
    );
  };
  

export default Unauthorized;